<template>
  <div style="position: relative">
    <PwdTip :value="showTooltip" :isdigit="isdigit" :islower="islower" :ismin="ismin" :isupper="isupper" />
    <v-form v-model="valid" v-on:submit.prevent>
      <v-text-field
        autofocus
        required
        outlined
        v-model="password"
        @focus="showTooltip = true"
        @blur="showTooltip = false"
        :rules="[rule.notRussian, rule.min, rule.upper, rule.lower, rule.digit]"
        :type="show1 ? 'text' : 'password'"
        name="pwd1"
        label="Придумайте пароль"
      >
        <template #append>
          <v-icon @click="show1 = !show1" tabindex="-1" v-if="show1">mdi-eye</v-icon>
          <v-icon @click="show1 = !show1" tabindex="-1" v-else>mdi-eye-off</v-icon>
        </template>
      </v-text-field>
    </v-form>
    <v-text-field
      :disabled="!valid"
      required
      outlined
      v-model="confirm"
      :rules="[rule.same]"
      :type="show2 ? 'text' : 'password'"
      name="pwd2"
      label="Повторите пароль"
    >
      <template #append>
        <v-icon @click="show2 = !show2" tabindex="-1" v-if="show2">mdi-eye</v-icon>
        <v-icon @click="show2 = !show2" tabindex="-1" v-else>mdi-eye-off</v-icon>
      </template>
    </v-text-field>

    <v-btn :disabled="!valid || password !== confirm" x-large block color="primary" @click="send">Продолжить</v-btn>
  </div>
</template>

<script>
import PwdTip from "@/components/common/PwdTip.vue";

export default {
  components: { PwdTip },
  props: {
    module: {
      type: String,
      default: "registration",
    },
  },
  computed: {
    ismin() {
      return this.rule.min(this.password) === true && this.rule.notRussian(this.password) === true;
    },
    isupper() {
      return this.rule.upper(this.password) === true;
    },
    islower() {
      return this.rule.lower(this.password) === true;
    },
    isdigit() {
      return this.rule.digit(this.password) === true;
    },
    password: {
      get() {
        return this.$store.state[this.module].pass;
      },
      set(value) {
        this.$store.commit(this.module + "/setPass", value);
      },
    },
    sendAction() {
      return this.module === "registration" ? "registration/register" : "login/recovery";
    },
  },
  data() {
    return {
      showTooltip: false,
      valid: false,
      show1: false,
      show2: false,
      confirm: "",
      rule: {
        min: (v) => v.length >= 6 || "Минимум 6 символов",
        notRussian: (v) => !/[А-Я]|[а-я]|\s/.test(v) || "Без пробелов и букв русского алфавита",
        upper: (v) => /[A-Z]/.test(v) || "Одна заглавная латинская буква",
        lower: (v) => /[a-z]/.test(v) || "Одна строчная латинская буква",
        digit: (v) => /\d/.test(v) || "Одна цифра",
        same: (v) => v === this.password || "Пароли не совпадают",
      },
    };
  },
  methods: {
    send() {
      this.$store.dispatch(this.sendAction);
      return;
    },
  },
};
</script>
